import { useEffect } from "react";
import { useField, useForm } from "react-final-form";

interface ContractItemFormValue {
  type?: string;
  amount?: unknown;
}

/**
 * У строки доли с продаж суммы быть не должно (validator бэкенда бросает
 * CONTRACT_ITEM_AMOUNT_INVALID). Поле "amount.value" при смене типа на
 * REVENUE_SHARE просто скрывается (isVisible), а его старое значение
 * остаётся в значениях формы и уходит в сабмит. Этот невидимый компонент
 * не рисует ничего, но следит за всем массивом строк и сбрасывает amount
 * у любой строки REVENUE_SHARE, у которой он ещё остался. Поставлен как
 * отдельное top-level поле формы, а не внутри subschema строки: у строк
 * массива nowrap-раскладка (ArrayItemRow), и лишнее xs:12-поле там сжало
 * бы видимые колонки. Поле "revenueShareHint" отдельного сброса не
 * требует, оно type: "readonly" и в значения формы не попадает вовсе.
 */
export function ContractItemsAmountGuard() {
  const form = useForm();
  const {
    input: { value: items },
  } = useField<ContractItemFormValue[]>("items", {
    subscription: { value: true },
  });

  useEffect(() => {
    (items || []).forEach((item, index) => {
      if (item?.type === "REVENUE_SHARE" && item?.amount) {
        form.change(`items[${index}].amount`, undefined);
      }
    });
  }, [items, form]);

  return null;
}
